export const ROOT_INFO_PROJECTION_DEBOUNCE_MS = 400;
export const ROOT_INFO_PROJECTION_RETRY_DELAYS_MS = Object.freeze([
  2000,
  5000,
  15000,
]);

export function getRootInfoProjection(nodes, rootId) {
  if (!rootId || !Array.isArray(nodes)) return '';
  const rootNode = nodes.find((node) => node?.id === rootId);
  return typeof rootNode?.info === 'string' ? rootNode.info : '';
}

export function projectionMatches(lastProjection, mindmapId, description) {
  return (
    lastProjection?.mindmapId === mindmapId
    && lastProjection?.description === description
  );
}
